import { useEffect, useRef } from 'preact/hooks';

export function useSortableList(onReorder: (from: number, to: number) => void) {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const onReorderRef = useRef(onReorder);
  onReorderRef.current = onReorder;
  useEffect(() => {
    if (!rootRef.current) return undefined;
    let disposed = false;
    let sortable: { destroy: () => void } | null = null;
    const root = rootRef.current;
    void import('sortablejs').then(({ default: Sortable }) => {
      if (disposed) return;
      sortable = Sortable.create(root, {
        animation: 180,
        chosenClass: 'is-sorting',
        dragClass: 'is-dragging',
        draggable: '[data-sort-id]',
        handle: '[data-drag-handle]',
        ghostClass: 'is-sort-ghost',
        onEnd: ({ oldIndex, newIndex }) => {
          if (oldIndex === undefined || newIndex === undefined || oldIndex === newIndex) return;
          onReorderRef.current(oldIndex, newIndex);
        },
      });
    });
    return () => { disposed = true; sortable?.destroy(); };
  }, []);
  return rootRef;
}

export function reorderItem<T>(items: readonly T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= items.length || to >= items.length) return [...items];
  const next = [...items];
  const [moved] = next.splice(from, 1);
  if (moved !== undefined) next.splice(to, 0, moved);
  return next;
}
